import { onMounted, ref } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { GET_LOCATION_BASED_FACTOR_TYPES } from '../helpers/apiURLS'
import { fetchApiData } from '../helpers/getApiData'

export type LocationBasedFactorType = {
    id: number
    name: string
}

export const useLocationBasedFactorTypes = createGlobalState(
    () => {
        const locationBasedFactorTypes = ref<LocationBasedFactorType[]>([])

        onMounted(async () => {
            const response = await fetchApiData<{ data: { data: LocationBasedFactorType[] } }>(GET_LOCATION_BASED_FACTOR_TYPES(), {
                sort_by: 'id',
                order_by: 'asc',
            })

            locationBasedFactorTypes.value = response.data?.data.data ?? []
        })

        return locationBasedFactorTypes
    },
)
